/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Desk_Sso_DisabledInputs */

const vi_error_desk_sso_disabled = /** @type {(inputs: Error_Desk_Sso_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng chuyển sang trang hỗ trợ chưa được bật. Vui lòng liên hệ quản trị viên.`)
};

/**

* @param {Error_Desk_Sso_DisabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_desk_sso_disabled = /** @type {((inputs?: Error_Desk_Sso_DisabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Desk_Sso_DisabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_desk_sso_disabled(inputs)
});